import { render, staticRenderFns } from "./AfterSalesDetail.vue?vue&type=template&id=bc29a01a&scoped=true"
import script from "./AfterSalesDetail.vue?vue&type=script&lang=js"
export * from "./AfterSalesDetail.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesDetail.vue?vue&type=style&index=0&id=bc29a01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc29a01a",
  null
  
)

export default component.exports